module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido10.86ee59ef.svg";